export const modalTitle = 'Are you over 18?'
export const modalText = 'To add this item to your order, please confirm you are over 18.'
export const underAgeModalText = 'Sorry, 18 is the minimum legal age required for this item'
